import { defineComponent as _defineComponent } from 'vue'
import {
  AbTitle,
  AbSection,
  AbContainer,
  AbIcon,
  AbSectionLayout,
  AbSlider,
  AbSliderItem,
  AbLink,
} from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';
import getBlockImage from '../../../../helpers/getBlockImage';
import getBlockImageAlt from '../../../../helpers/getBlockImageAlt';
import { CdnImg } from '@webplatform/cdn-image';
import { useBreakpoints } from '@vueuse/core';
import { APP_GRID_BREAKPOINTS } from '../../../../composables/constants';
import { computed } from 'vue';

interface Props {
  id?: string | null;
  items: {
    title?: string | null;
    subtitle?: string | null;
    link?: {
      url: string | null;
      text?: string | null;
    } | null;
    image?:
      | {
          src?: string | null;
          alt?: string | null;
        }
      | string
      | null;
  }[];
  spacing?: Spacing | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionAdvertisement',
  props: {
    id: null,
    items: null,
    spacing: null
  },
  setup(__props: any) {

const DEFAULT_TEXT_ALIGN = 'left';
const DEFAULT_TEXT = '';



const breakpoints = useBreakpoints(APP_GRID_BREAKPOINTS);

const isLaptopAndGreater = computed(() => breakpoints.greater('lg').value);
const isTabletAndGreater = breakpoints.greater('md').value;

return { __sfc: true,DEFAULT_TEXT_ALIGN, DEFAULT_TEXT, breakpoints, isLaptopAndGreater, isTabletAndGreater, AbTitle, AbSection, AbContainer, AbIcon, AbSectionLayout, AbSlider, AbSliderItem, AbLink, getBlockImage, getBlockImageAlt, CdnImg }
}

})